import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

const store = () => (localStorage.getItem("cc_token") ? localStorage : sessionStorage);

export const getToken = () => localStorage.getItem("cc_token") || sessionStorage.getItem("cc_token");

export const setTokens = (token, refresh, remember) => {
  const s = remember === undefined ? store() : (remember ? localStorage : sessionStorage);
  const other = s === localStorage ? sessionStorage : localStorage;
  other.removeItem("cc_token"); other.removeItem("cc_refresh");
  s.setItem("cc_token", token);
  if (refresh) s.setItem("cc_refresh", refresh);
};

export const clearTokens = () => {
  ["cc_token", "cc_refresh"].forEach((k) => { localStorage.removeItem(k); sessionStorage.removeItem(k); });
};

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshing = null;

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err.config || {};
    const isAuthCall = (cfg.url || "").startsWith("/auth/");
    if (err.response && err.response.status === 401 && !cfg._retried && !isAuthCall) {
      const refresh = localStorage.getItem("cc_refresh") || sessionStorage.getItem("cc_refresh");
      if (refresh) {
        try {
          refreshing = refreshing || axios.post(`${API}/auth/refresh`, { refresh_token: refresh });
          const r = await refreshing;
          setTokens(r.data.token, r.data.refresh_token);
          cfg._retried = true;
          cfg.headers.Authorization = `Bearer ${r.data.token}`;
          return api(cfg);
        } catch (_) { /* fall through to sign-out */ } finally { refreshing = null; }
      }
      clearTokens();
      if (!["/", "/signup", "/forgot-password", "/reset-password"].includes(window.location.pathname)) {
        window.location.href = "/?expired=1";
      }
    }
    if (!err.response) err.friendly = "Network error — check your connection and try again.";
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  if (e?.response?.status === 403 && !d) return "You don't have permission to do that.";
  return d || e?.friendly || fallback;
};

export default api;
